<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-rain`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39.58 16.58C38.052 10.5 32.551 6 26 6c-6.445 0-11.758 3.587-13.511 9.012C6.651 15.279 2 20.096 2 26c0 6.075 5.128 10 11.203 10L13 32l-.24-.004A7 7 0 016 25c0-3.866 3.134-6 7-6h2.873l.003-.27C16.022 13.626 20.278 10 26 10c5.523 0 10.232 3.998 10.232 9.521l2.24.284c2.406.71 4.035 2.686 4.213 5.195.226 3.163-3.371 7-6.685 7l.232 4 .271.006c5.397.038 9.718-5.074 9.718-10.506 0-4.236-2.779-7.618-6.642-8.92zM23.195 27.691l1.638 1.148a1 1 0 01.246 1.392l-6.883 9.83a1 1 0 01-1.393.246l-1.638-1.148a1 1 0 01-.246-1.392l6.883-9.83a1 1 0 011.393-.246zm10 1l1.638 1.148a1 1 0 01.246 1.392l-6.883 9.83a1 1 0 01-1.393.246l-1.638-1.148a1 1 0 01-.246-1.392l6.883-9.83a1 1 0 011.393-.246z"/></svg>
</template>
<script>

export default {
  name: 'IconRain',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
